/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { PasswordResetRedirect } from '../../components/password-reset/PasswordResetRedirect';

import { RouteInterface } from '../../types/routes';

export const passwordResetRedirectRoute: RouteInterface = {
  id: 'passwordReset',
  label: 'Password Reset',
  path: '/password-reset',
  exact: true,
  component: PasswordResetRedirect,
};
